import type { ItemFieldRow } from './item-field-reader';

/** Borrow a held row; only overrides and removed keys belong to this view. */
export function layerReadView(source: ItemFieldRow, overrides: Record<string, unknown> = {}, omit: readonly string[] = []): Record<string, unknown> {
    const removed = new Set<PropertyKey>(omit);
    const own = (value: object, key: PropertyKey): boolean => Object.prototype.hasOwnProperty.call(value, key);
    return new Proxy(overrides, {
        get: (target, key) => removed.has(key) ? undefined : Reflect.get(own(target, key) ? target : source, key),
        has: (target, key) => !removed.has(key) && (own(target, key) || own(source, key)),
        ownKeys: target => [...new Set([...Reflect.ownKeys(source), ...Reflect.ownKeys(target)])].filter(key => !removed.has(key)),
        getOwnPropertyDescriptor: (target, key) => removed.has(key) ? undefined
            : own(target, key) ? Reflect.getOwnPropertyDescriptor(target, key)
            : own(source, key) ? { value: Reflect.get(source, key), enumerable: Reflect.getOwnPropertyDescriptor(source, key)?.enumerable,
                configurable: true, writable: true } : undefined,
        set: (target, key, value) => { removed.delete(key); return Reflect.set(target, key, value); },
        defineProperty: (target, key, descriptor) => { removed.delete(key); return Reflect.defineProperty(target, key, descriptor); },
        deleteProperty: (target, key) => { removed.add(key); return Reflect.deleteProperty(target, key); },
    });
}
